import Vue from 'vue'
import VueJwtDecode from 'vue-jwt-decode';
import { VersionIxeEnum } from '@/utils/enums/VersionIxeEnum';
import _ from 'lodash';

const General = {
  methods: {
    Obtener_Url(url) {
      return (_.get(this.store, 'state.menu.usuario.sistema', null) == VersionIxeEnum.R3 ? 'r3/' + url : url);
    },
    get_ptc_url(url) {
      return (Vue.http.options.url + 'ptc/' + url);
    },
    get_public_url(url) {
      return (Vue.http.options.url + 'pub/' + url);
    },
    get_protected_url(url) {
      return (Vue.http.options.url + 'ptc/' + url);
    },
    get_request_headers(data) {
      const headers = {};
      const { token, accesstoken } = data;
      if (token) {
        headers.Authorization = 'Bearer ' + token;
      }
      if (accesstoken) {
        headers.accesstoken = accesstoken
      }

      return headers;
    },
    get_token_contents(token_str) {
      const tkn_str_regexp = new RegExp('^[\'\"]', 'i');
      const has_quotes = tkn_str_regexp.test(token_str);
      if ( _.isString(token_str) && has_quotes ) {
        return null;
      } else {
        return VueJwtDecode.decode(token_str);
      }
    }
  }
};

export default General;
